import { useCallback, useRef, useState } from "react";

import { IconAdjustmentsHorizontal } from "@tabler/icons";
import { useTheme } from "styled-components";

import { useClickAwayListener } from "@sso/hooks/useClickAwayListener";
import { TableColumn } from "@sso/types";
import { Wrapper } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";
import { MenuContainer, MenuItem } from "@sso/ui/Menu";

interface TableSearchMenuProps {
  searchItems: TableColumn[];
  onChangeSearchMenu?: (item: TableColumn) => void;
}

export const TableSearchMenu = ({ searchItems, onChangeSearchMenu }: TableSearchMenuProps) => {
  const theme = useTheme();
  const [searchMenu, setSearchMenu] = useState(false);
  const searchMenuRef = useRef<HTMLDivElement>(null!);

  const closeSearchMenu = useCallback(() => setSearchMenu(false), []);
  useClickAwayListener(searchMenuRef, closeSearchMenu);

  const handleOpenSearchMenu = () => setSearchMenu(prev => !prev);

  const handleOnMenuClick = (item: TableColumn) => {
    onChangeSearchMenu && onChangeSearchMenu(item);
    closeSearchMenu();
  };

  return (
    <Wrapper position="relative" ref={searchMenuRef}>
      <IconButton
        color={theme.colors.grey.default}
        hoverColor={theme.colors.warning.main}
        onClick={handleOpenSearchMenu}
      >
        <IconAdjustmentsHorizontal />
      </IconButton>
      {searchMenu && (
        <MenuContainer right="0" top="120%">
          {searchItems.map(item => (
            <MenuItem key={item.field as string} onClick={() => handleOnMenuClick(item)}>
              {item.name}
            </MenuItem>
          ))}
        </MenuContainer>
      )}
    </Wrapper>
  );
};
